import React, { PureComponent } from 'react';
import compact from 'lodash/compact';
import find from 'lodash/find';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import * as analytics from 'shared/lib/analytics';
import AddressSection from 'shared/lib/components/AddressSection';
import ConfirmationLayout from 'shared/lib/components/ConfirmationLayout';
import LineItemsList from 'shared/lib/components/LineItemsList';
import SectionWrapper from 'shared/lib/components/SectionWrapper';

const propTypes = {
  account: PropTypes.shape({
    phoneNumber: PropTypes.string,
  }),
  airlines: PropTypes.array,
  baggageAirline: PropTypes.string,
  baggageConfirmationNumber: PropTypes.string,
  baggageLocation: PropTypes.shape({
    streetAddress: PropTypes.string,
    unit: PropTypes.string,
    city: PropTypes.string,
    region: PropTypes.string,
    postal: PropTypes.string,
  }).isRequired,
  baggagePassengerInfo: PropTypes.shape({
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  baggagePlans: PropTypes.array,
  baggagePurchase: PropTypes.shape({
    policy_number: PropTypes.string,
  }).isRequired,
  disclaimer: PropTypes.string,
  baggageSelectedPlanId: PropTypes.string,
  totals: PropTypes.shape({
    grandtotal: PropTypes.number,
  }).isRequired,
};

const defaultProps = {
  account: {},
  airlines: [],
  baggageAirline: '',
  baggageConfirmationNumber: '',
  baggageLocation: {},
  baggagePassengerInfo: {},
  baggagePlans: [],
  baggagePurchase: {},
  disclaimer: null,
  baggageSelectedPlanId: null,
  totals: {},
};

class BaggageConfirmationView extends PureComponent {
  componentDidMount() {
    analytics.page('BRB - Confirmation');
    analytics.track('Checkout Step Viewed', {
      step: 3,
    });
  }

  get plan() {
    return find(this.props.baggagePlans, {
      plan_id: this.props.baggageSelectedPlanId,
    });
  }

  get flightName() {
    const airline = find(this.props.airlines, {
      fs: this.props.baggageAirline,
    });
    return get(airline, 'name');
  }

  render() {
    return (
      <div className="BaggageConfirmationView Container Container--small">
        <ConfirmationLayout
          policyNumber={this.props.baggagePurchase.policy_number}
          policyDocUrl={get(this.plan, 'policy_doc_url')}
          icon="work"
          totals={this.props.totals}
          phoneNumber={this.props.account.phoneNumber}
          disclaimer={this.props.disclaimer}
        >
          <SectionWrapper title="Flight details">
            <p>
              {this.flightName}
              <br />
              Confirmation #{this.props.baggageConfirmationNumber}
            </p>
          </SectionWrapper>

          <SectionWrapper title="Passenger details">
            <p>
              {compact([
                this.props.baggagePassengerInfo.firstName,
                this.props.baggagePassengerInfo.middleName,
                this.props.baggagePassengerInfo.lastName,
              ]).join(' ')}
            </p>
            <AddressSection address={this.props.baggageLocation} />
            <p>
              {this.props.baggagePassengerInfo.email}
              <br />
              {this.props.baggagePassengerInfo.phone}
            </p>
          </SectionWrapper>

          <SectionWrapper>
            <LineItemsList
              rows={[
                ['Underwritten By', 'Blue Ribbon Bags'],
                [
                  'Coverage',
                  get(this.plan, 'information.subtitle').split(' ')[0],
                ],
              ]}
            />
          </SectionWrapper>
        </ConfirmationLayout>
      </div>
    );
  }
}

BaggageConfirmationView.propTypes = propTypes;
BaggageConfirmationView.defaultProps = defaultProps;

export default BaggageConfirmationView;
